import * as React from 'react'
import { Button, Input } from '@mobiscroll/react-latest'
import { debounce } from 'throttle-debounce'
import { handleRedirect } from 'src/utils'
import StationUserTable from '../../containers/station-user/StationUserTable'
import UIMessages from '../../utils/ui-messages'
import FindIcon from '../icons/ui/Find'
import HorizontalSelector from '../HorizontalSelector'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import { IStationUserFilters } from '../../types'
import Plus from '../icons/organizations/Plus'

interface ITTPProps {
  currentOrgId: string
}

interface ITTPState {
  filters: IStationUserFilters
}

export default class StationUserTablePane extends React.Component<ITTPProps, ITTPState> {
  public state: ITTPState = {
    filters: {
      isArchived: false,
      search: '',
      orgId: this.props.currentOrgId
    }
  }

  public searchMembersDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
  })

  public componentDidUpdate(prevProps: ITTPProps) {
    if (this.props.currentOrgId !== prevProps.currentOrgId) {
      this.setState({ filters: { ...this.state.filters, orgId: this.props.currentOrgId } })
    }
  }

  public render() {
    const { filters } = this.state
    const {
      common: { search },
      stationUser: { archivedStationUser, createStationUser, stationUser }
    } = UIMessages

    return (
      <React.Fragment>
        <div className='flex items-center justify-between p2'>
          <HorizontalSelector>
            <HorizontalSelectorItem isSelected={!filters.isArchived}>
              <div className='uppercase cursor--pointer' onClick={this.setArchived(false)}>
                {stationUser}
              </div>
            </HorizontalSelectorItem>
            <HorizontalSelectorItem isSelected={filters.isArchived}>
              <div className='uppercase cursor--pointer' onClick={this.setArchived(true)}>
                {archivedStationUser}
              </div>
            </HorizontalSelectorItem>
          </HorizontalSelector>
          <div className='column-gap-8 flex flex-row'>
            <div className='flex items-center relative'>
              <Input
                className='mbsc-input-with-start-icon mbsc-input-with-start-icon-label'
                inputStyle='box'
                label={search}
                labelStyle='floating'
                theme='ios'
                type='text'
                onChange={this.searchMembers}
              />
              <FindIcon className='absolute ml1 svg-stroke-grey2' />
            </div>
            <div className='flex items-center relative'>
              <Button
                ariaLabel='Redirect to create station user component'
                className='mbsc-btn-with-start-icon mbsc-success-btn'
                onClick={() => handleRedirect('/station-user/create')}
              >
                {createStationUser}
              </Button>
              <Plus className='absolute ml2 z1' />
            </div>
          </div>
        </div>
        <StationUserTable filters={filters} />
      </React.Fragment>
    )
  }

  private searchMembers = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e && e.target.value ? e.target.value : ''
    this.searchMembersDebounced(search)
  }

  private setArchived = (isArchived: boolean) => {
    return (e: any) => {
      this.setState({ filters: { ...this.state.filters, isArchived } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/station-user/StationUserTablePane.tsx